export enum LOCALES {
  NL = "nl",
  EN = "en",
}
